export const REQUIRED = 'Required.';

/**
 * NOTE: There are certain usecases where this function will return an error even if the value
 * passed in should be valid. See unit tests.
 *
 * @param value The value to be checked for if the user has input anything
 */
const required = (value: any): true | string => {
  if (typeof value === 'string') {
    return value.trim() !== '' || REQUIRED;
  }

  return !!value || REQUIRED;
};

export default required;
